// @flow
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  couponRequest: ['data'],
  couponSuccess: ['data'],
  couponFailure: ['err'],

  couponDetailRequest: ['data'],
  couponDetailSuccess: ['data'],
  couponDetailFailure: ['err'],

  couponTagRequest: ['data'],
  couponTagSuccess: ['data'],
  couponTagFailure: ['err'],

  couponCreateRequest: ['data'],
  couponCreateSuccess: ['data'],
  couponCreateFailure: ['err'],

  couponGenerateRequest: ['data'],
  couponGenerateSuccess: ['data'],
  couponGenerateFailure: ['err'],

  couponUpdateRequest: ['data'],
  couponUpdateSuccess: ['data'],
  couponUpdateFailure: ['err'],

  businessUpdateRequest: ['data'],
  businessUpdateSuccess: ['data'],
  businessUpdateFailure: ['err'],

  couponDeleteRequest: ['id'],
  couponDeleteSuccess: ['data'],
  couponDeleteFailure: ['err'],

  businessDeleteRequest: ['id'],
  businessDeleteSuccess: ['data'],
  businessDeleteFailure: ['err'],

  couponSpreadsheetRequest: ['data'],
  couponSpreadsheetSuccess: ['data'],
  couponSpreadsheetFailure: ['err'],

  historySpreadsheetRequest: ['data'],
  historySpreadsheetSuccess: ['data'],
  historySpreadsheetFailure: ['err'],

  getCouponItemRequest: ['data'],
  getCouponItemSuccess: ['data'],
  getCouponItemFailure: ['err'],

  postCouponItemRequest: ['data'],
  postCouponItemSuccess: ['data'],
  postCouponItemFailure: ['err'],

  postCouponItemTagRequest: ['data'],
  postCouponItemTagSuccess: ['data'],
  postCouponItemTagFailure: ['err'],

  deleteCouponItemRequest: ['data'],
  deleteCouponItemSuccess: ['data'],
  deleteCouponItemFailure: ['err'],

  deleteCouponItemTagRequest: ['data'],
  deleteCouponItemTagSuccess: ['data'],
  deleteCouponItemTagFailure: ['err'],

  getAffiliatesRequest: ['data'],
  getAffiliatesSuccess: ['data'],
  getAffiliatesFailure: ['data'],

  affiliateTransferRequest: ['data'],
  affiliateTransferSuccess: ['data'],
  affiliateTransferFailure: ['err']
})

export const CouponTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  data: null,
  spreadsheet: null,
  detail: {},
  couponitem: [],
  affiliates: [],
  err: null,
  processing: false,
  success: null
})

/* ------------- Reducers ------------- */
export const request = (state: Object) => state.merge({ fetching: true, err: null, success: null, spreadsheet: null })

export const success = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data,
    err: null
  })

export const successDetail = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    detail: data,
    err: null
  })

export const successItem = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    couponitem: data,
    err: null
  })

export const successAffiliates = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    affiliates: data,
    err: null
  })

export const successSpreadsheet = (state: Object, {data}: Object) =>
  state.merge({
    fetching: false,
    spreadsheet: data,
    err: null
  })

// we've had a problem logging in
export const failure = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err })

export const manipulateRequest = (state: Object) => state.merge({ processing: true, success: null })
export const manipulateSuccess = (state: Object, { data }: Object) =>
  state.merge({
    processing: false,
    success: true,
    err: null
  })
export const manipulateFailure = (state: Object, { err }: Object) =>
state.merge({ processing: false, err, success: null })

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.COUPON_SUCCESS]: success,
  [Types.COUPON_REQUEST]: request,
  [Types.COUPON_FAILURE]: failure,

  [Types.COUPON_DETAIL_SUCCESS]: successDetail,
  [Types.COUPON_DETAIL_REQUEST]: request,
  [Types.COUPON_DETAIL_FAILURE]: failure,

  [Types.COUPON_TAG_SUCCESS]: success,
  [Types.COUPON_TAG_REQUEST]: request,
  [Types.COUPON_TAG_FAILURE]: failure,

  [Types.COUPON_CREATE_SUCCESS]: manipulateSuccess,
  [Types.COUPON_CREATE_REQUEST]: manipulateRequest,
  [Types.COUPON_CREATE_FAILURE]: manipulateFailure,

  [Types.COUPON_GENERATE_SUCCESS]: manipulateSuccess,
  [Types.COUPON_GENERATE_REQUEST]: manipulateRequest,
  [Types.COUPON_GENERATE_FAILURE]: manipulateFailure,

  [Types.COUPON_UPDATE_SUCCESS]: manipulateSuccess,
  [Types.COUPON_UPDATE_REQUEST]: manipulateRequest,
  [Types.COUPON_UPDATE_FAILURE]: manipulateFailure,

  [Types.BUSINESS_UPDATE_SUCCESS]: manipulateSuccess,
  [Types.BUSINESS_UPDATE_REQUEST]: manipulateRequest,
  [Types.BUSINESS_UPDATE_FAILURE]: manipulateFailure,

  [Types.COUPON_DELETE_SUCCESS]: manipulateSuccess,
  [Types.COUPON_DELETE_REQUEST]: manipulateRequest,
  [Types.COUPON_DELETE_FAILURE]: manipulateFailure,

  [Types.BUSINESS_DELETE_SUCCESS]: manipulateSuccess,
  [Types.BUSINESS_DELETE_REQUEST]: manipulateRequest,
  [Types.BUSINESS_DELETE_FAILURE]: manipulateFailure,

  [Types.COUPON_SPREADSHEET_SUCCESS]: successSpreadsheet,
  [Types.COUPON_SPREADSHEET_REQUEST]: request,
  [Types.COUPON_SPREADSHEET_FAILURE]: failure,

  [Types.HISTORY_SPREADSHEET_SUCCESS]: successSpreadsheet,
  [Types.HISTORY_SPREADSHEET_REQUEST]: request,
  [Types.HISTORY_SPREADSHEET_FAILURE]: failure,

  [Types.GET_COUPON_ITEM_SUCCESS]: successItem,
  [Types.GET_COUPON_ITEM_REQUEST]: request,
  [Types.GET_COUPON_ITEM_FAILURE]: failure,

  [Types.POST_COUPON_ITEM_SUCCESS]: manipulateSuccess,
  [Types.POST_COUPON_ITEM_REQUEST]: manipulateRequest,
  [Types.POST_COUPON_ITEM_FAILURE]: manipulateFailure,

  [Types.POST_COUPON_ITEM_TAG_SUCCESS]: manipulateSuccess,
  [Types.POST_COUPON_ITEM_TAG_REQUEST]: manipulateRequest,
  [Types.POST_COUPON_ITEM_TAG_FAILURE]: manipulateFailure,

  [Types.DELETE_COUPON_ITEM_SUCCESS]: manipulateSuccess,
  [Types.DELETE_COUPON_ITEM_REQUEST]: manipulateRequest,
  [Types.DELETE_COUPON_ITEM_FAILURE]: manipulateFailure,

  [Types.DELETE_COUPON_ITEM_TAG_SUCCESS]: manipulateSuccess,
  [Types.DELETE_COUPON_ITEM_TAG_REQUEST]: manipulateRequest,
  [Types.DELETE_COUPON_ITEM_TAG_FAILURE]: manipulateFailure,

  [Types.GET_AFFILIATES_SUCCESS]: successAffiliates,
  [Types.GET_AFFILIATES_REQUEST]: request,
  [Types.GET_AFFILIATES_FAILURE]: failure,

  [Types.AFFILIATE_TRANSFER_SUCCESS]: manipulateSuccess,
  [Types.AFFILIATE_TRANSFER_REQUEST]: manipulateRequest,
  [Types.AFFILIATE_TRANSFER_FAILURE]: manipulateFailure
})



// WEBPACK FOOTER //
// ./src/Redux/CouponRedux.js